<template>
  <div class="ui" v-if="data && !data.disabled">
    <Input
      v-if="
        ['text', 'password', 'phone', 'number', 'email'].indexOf(data.type) > -1
      "
      :data="data"
      :all="all"
      @set="$emit('set', $event)"
    />
    <Files
      v-if="['file'].indexOf(data.type) > -1"
      :data="data"
      @set="$emit('set', $event)"
    />
    <Selectbox
      v-if="['select'].indexOf(data.type) > -1"
      :data="data"
      :all="all"
      @set="$emit('set', $event)"
    />
    <Datepicker
      v-if="['date'].indexOf(data.type) > -1"
      :data="data"
      @set="$emit('set', $event)"
    />
    <Editor
      v-if="['editor'].indexOf(data.type) > -1"
      :data="data"
      @set="$emit('set', $event)"
    />
    <Toggler
      v-if="['toggler'].indexOf(data.type) > -1"
      :data="data"
      @set="$emit('set', $event)"
    />
  </div>
</template>

<script>
import Input from "@/components/ui/Input";
import Files from "@/components/ui/Files";
import Selectbox from "@/components/ui/Selectbox";
import Datepicker from "@/components/ui/Datepicker";
import Editor from "@/components/ui/Editor";
import Toggler from "@/components/ui/Toggler";

export default {
  props: {
    data: Object,
    all: Object,
  },
  components: {
    Input,
    Files,
    Selectbox,
    Datepicker,
    Editor,
    Toggler,
  },
};
</script>

<style lang="scss" scoped>
.ui {
  @include box(100%, auto, relative, null, null, null, null, null, null);
}
</style>
